import SvgIcon from '@mui/material/SvgIcon';

export default function SvgIconProvider() {
	return (
		<SvgIcon>
			<svg fill="none" viewBox="0 0 72 72" strokeWidth={1.5} stroke="currentColor">
				<path fill="#0A0A0A" opacity="1.000000" stroke="none"
					d="M11.385166,7.694031 
	C13.312401,6.411743 15.117440,4.863545 16.949505,4.830877 
	C29.099489,4.614226 41.255802,4.787582 53.408855,4.687881 
	C57.398403,4.655150 59.113274,6.194479 59.088329,10.307563 
	C58.977276,28.620977 58.967644,46.935951 59.093937,65.249168 
	C59.124313,69.654007 57.179588,71.115273 53.042179,71.077286 
	C41.055790,70.967232 29.067097,70.968430 17.080669,71.076759 
	C12.817682,71.115288 11.146947,69.324730 11.175688,65.067627 
	C11.303816,46.088779 11.258267,27.108759 11.385166,7.694031 
M26.580795,36.171425 
	C23.828638,36.171425 21.076479,36.171425 18.333664,36.171425 
	C18.333664,39.371597 18.333664,41.788219 18.333664,44.426865 
	C29.666445,44.426865 40.709961,44.426865 51.797287,44.426865 
	C51.797287,41.584007 51.797287,39.046738 51.797287,36.171429 
	C43.465229,36.171429 35.513603,36.171429 26.580795,36.171425 
M34.500847,11.778339 
	C29.085354,11.778339 23.669861,11.778339 18.454571,11.778339 
	C18.454571,15.042172 18.454571,17.450119 18.454571,19.759672 
	C29.875826,19.759672 40.928120,19.759672 51.785301,19.759672 
	C51.785301,16.898445 51.785301,14.487401 51.785301,11.778336 
	C46.123032,11.778336 40.811531,11.778336 34.500847,11.778339 
M46.445580,32.360321 
	C48.215363,32.360321 49.985146,32.360321 51.895325,32.360321 
	C51.895325,29.316587 51.895325,26.906036 51.895325,24.291615 
	C40.608315,24.291615 29.565865,24.291615 18.359325,24.291615 
	C18.359325,27.018440 18.359325,29.420565 18.359325,32.360245 
	C27.565472,32.360245 36.513046,32.360245 46.445580,32.360321 
M44.863560,57.292503 
	C45.469242,58.899368 45.656185,61.182343 46.813244,61.898949 
	C47.737118,62.471138 50.133102,61.480576 51.298351,60.498611 
	C51.864109,60.021851 51.355465,56.931095 50.906113,56.824520 
	C49.121582,56.401268 47.168606,56.688202 44.863560,57.292503 
z"/>
			</svg>
		</SvgIcon>
	);
}